module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_02.f0b95197.jpg";